// extracted by mini-css-extract-plugin
export default {"products":"iC-z","card":"jC-z","oosMessaging":"kC-z"};